import dayjs from "dayjs";
import {
  Document,
  Font,
  Image,
  // Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
// import logoDark from "../../assets/img/logo/logo-dark.png";
import logoDark from "../../assets/img/logo/sim_new_white.jpg";
import { showDateFormat } from "utils/dateFormate";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
  ],
});
Font.register({
  family: "DejaVu Sans",
  fonts: [
    {
      src: "https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans.ttf",
    },
    {
      src: "https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    marginRight: 10,
    marginBottom: 20,
    marginLeft: 10,
    paddingTop: 30,
    paddingLeft: 10,
    paddingRight: 29,
    lineHeight: 1.5,
  },
  table: {
    display: "table",
    width: "auto",
    color: "#4b5563",
    marginRight: 10,
    marginBottom: 20,
    marginLeft: 10,
    marginTop: 0,
    borderRadius: "8px",
    borderColor: "#e9e9e9",
    borderStyle: "solid",
    borderWidth: 0.5,
    padding: 0,
    textAlign: "left",
  },
  tableRow: {
    // margin: 'auto',
    flexDirection: "row",
    paddingBottom: 2,
    paddingTop: 2,
    textAlign: "left",
    borderWidth: 0.8,
    borderColor: "#E5E7EB",
    borderBottom: "0",
  },
  tableRowHeder: {
    // margin: 'auto',
    flexDirection: "row",
    backgroundColor: "#f9fafb",
    paddingBottom: 4,
    paddingTop: 4,
    paddingLeft: 0,
    borderBottomWidth: 0.8,
    borderColor: "#E5E7EB",
    borderStyle: "solid",
    textTransform: "uppercase",
    textAlign: "left",
  },
  tableCol: {
    width: "25%",
    textAlign: "left",

    // borderStyle: 'solid',
    // borderWidth: 1,
    // borderLeftWidth: 0.5,
    // borderTopWidth: 0.5,
    // borderBottomWidth: 0.5,
    // borderColor: '#d1d5db',
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    // textAlign:'center',
    paddingLeft: "0",
    paddingRight: "0",
    marginLeft: "13",
    marginRight: "13",
  },

  tableCellQuantity: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    textAlign: "center",
    paddingLeft: "0",
    paddingRight: "0",
    marginLeft: "12",
    marginRight: "12",
  },

  invoiceFirst: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: 18,
    paddingLeft: 10,
    paddingRight: 10,
    borderBottom: 1,
    borderColor: "#f3f4f6",
    // backgroundColor:'#EEF2FF',
  },
  invoiceSecond: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingTop: 20,
    paddingBottom: 10,
    // backgroundColor:'#EEF2FF',
    paddingLeft: 10,
    paddingRight: 10,
  },

  invoiceThird: {
    display: "flex",
    flexDirection: "col",

    justifyContent: "flex-end",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 10,
    paddingRight: 10,
    borderTop: 1,
    borderColor: "#ffffff",
    backgroundColor: "#f4f5f7",
    borderRadius: 12,
    marginLeft: "13",
    marginRight: "13",

    // backgroundColor:'#F2FCF9',
  },
  logo: {
    width: 80,
    height: 40,
    bottom: 5,
    right: 0,
    marginBottom: 10,
    textAlign: "right",
    color: "#4b5563",
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 10.3,

    // marginRight: "2%",
    textTransform: "uppercase",
  },
  title: {
    color: "#2f3032",
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 8.1,
    textTransform: "uppercase",
  },
  info: {
    fontSize: 9,
    color: "#6b7280",
  },
  infoCost: {
    fontSize: 10,
    color: "#6b7280",
    marginLeft: "4%",
    marginTop: "7px",
    textAlign: "left",
    width: "25%",
  },
  invoiceNum: {
    fontSize: 9,
    color: "#6b7280",
    marginLeft: "6%",
  },
  topAddress: {
    fontSize: 10,
    color: "#6b7280",
    width: "100%",
    marginRight: "62%",
    textAlign: "right",
    whiteSapce: "nowrap",
  },
  amount: {
    fontSize: 10,
    color: "#ef4444",
  },
  totalAmount: {
    fontSize: 10,
    color: "#ef4444",
    fontFamily: "Open Sans",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "right",
  },
  status: {
    color: "#10b981",
  },
  quantity: {
    color: "#1f2937",
    textAlign: "center",
  },
  itemPrice: {
    color: "#1f2937",
    textAlign: "left",
  },
  header: {
    color: "#6b7280",
    fontSize: 9,
    fontFamily: "Open Sans",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "left",
  },

  thanks: {
    color: "#22c55e",
  },
  infoRight: {
    textAlign: "right",
    fontSize: 9,
    color: "#6b7280",
    width: "25%",
    marginRight: "39%",
    fontFamily: "Open Sans",
    fontWeight: "bold",
  },
  titleRight: {
    textAlign: "right",
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 8.1,
    width: "25%",
    marginRight: "39%",
    textTransform: "uppercase",
    color: "#2f3032",
  },
  topBg: {
    // backgroundColor:'#EEF2FF',
  },
  invoiceDiv: {
    alignItems: "baseline",
  },
});

const InvoiceForDownload = ({ rows, data, currency, globalSetting }) => {
  // Language Translation RMK
  const { t } = useTranslation();

  return (
    <>
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.invoiceFirst}>
            <View style={styles.invoiceDiv}>
              <Text
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  alignItems: "baseline",
                }}
              >
                {t("Quote")}
              </Text>
              {/* <Text style={styles.info}>
                {t('Status')} :{" "}

                {data?.status === "Draft" && (
                  <span style={{ color: "#eab308" }}>{data?.status}</span>
                )}
                {data?.status === "New" && (
                  <span style={{ color: "blue" }}>{data?.status}</span>
                )}
                {data?.status === "Modified" && (
                  <span style={{ color: "#14b8a6" }}>{data?.status}</span>
                )}

                {data?.status === "Accepted" && (
                  <span style={{ color: "#22c55e" }}>{data?.status}</span>
                )}

                {data?.status === "Rejected" && (
                  <span style={{ color: "#f43f5e" }}>{data?.status}</span>
                )}
                {data?.status === "Expired" && (
                  <span style={{ color: "#f43f5e" }}>{data?.status}</span>
                )}
              </Text> */}
             
            </View>

            <View style={styles.logo}>
         
                <Image
                  src={logoDark}
                  alt="SIM"
                  style={{
                    width: 80,
                  }}
                />
            
           
            </View>
          </View>

          <View style={styles.invoiceSecond}>
            <View>
              <Text style={styles.title}>{t("Quote Date")}</Text>
              <Text style={styles.info}>
                {data?.quoteDate !== undefined && (
                  <span>
                    {dayjs(data?.quoteDate).format("MMMM D, YYYY")}
                  </span>
                )}
              </Text>
              <Text style={styles.title}>{t("Expiration Date")}</Text>

              <Text style={styles.info}>
                {data?.expirationDate !== undefined && (
                  <span>
                    {dayjs(data?.expirationDate).format("MMMM D, YYYY")}
                  </span>
                )}
              </Text>
            </View>
            <View>
              <Text style={styles.title}> {t("Quote No")}</Text>
              <Text style={styles.invoiceNum}>#{t('Quote')}{'-'}{data?.id}</Text>
            </View>

            <View>
              <Text style={styles.titleRight}>{t("Quote To")}</Text>
              {/* <Text style={styles.infoRight}>{data?.user_info?.name}</Text> */}
              {data.user ? (
                <>
                  <Text style={styles.infoRight}>{data?.user?.name}</Text>
                  <Text style={styles.infoRight}>
                  {data?.user?.email}{" "}
                  
                </Text>
                <Text style={styles.infoRight}><span className="ml-2">{data?.user?.phone}</span>
                </Text>
                <Text style={styles.infoRight}>
                <span className="ml-2">{data?.user?.tax_number}</span>
                </Text>
                  <Text style={styles.infoRight}>
                    {/* {" "}
                {data?.user?.address?.substring(0, 30)} */}
                    <br />
                    {data?.user?.city && data?.user?.country && data?.user?.zipCode && 
                   ( <>{data?.user?.city}, {data?.user?.country},{" "}
                    {data?.user?.zip}</>)}
                  </Text>
                </>
              ) : (<><Text style={styles.infoRight}>{data?.quote?.name}</Text>
                <Text style={styles.infoRight}>
                  {data?.quote?.email}{" "}
                  
                </Text>
                <Text style={styles.infoRight}><span className="ml-2">{data?.quote?.phone}</span>
                </Text>
                <Text style={styles.infoRight}>
                <span className="ml-2">{data?.quote?.tax_number}</span>
                </Text>
                
                <Text style={styles.infoRight}>
                  {/* {" "}
                  {data?.user?.address?.substring(0, 30)} */}
                  <br />
                  {data?.quote?.city && data?.quote?.country && data?.quote?.zipCode && 
                   ( <>{data?.quote?.city}, {data?.quote?.country},{" "}
                    {data?.quote?.zip}</>)}
                </Text></>)}
              {/* {data?.sellFrom === "SHOP" && (
                <>
                  <Text style={styles.infoRight}>
                    {data?.user_info?.address?.substring(0, 25)}
                  </Text>
                  <Text style={styles.infoRight}>
                    {data?.user_info?.city}, {data?.user_info?.country},
                    {data?.user_info?.zipCode}
                  </Text>
                </>
              )} */}
            </View>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRowHeder}>
              {/* <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  <span style={styles.header}>{t('sr')}</span>
                </Text>
              </View> */}
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  <span
                    style={{
                      color: "#6b7280",
                      fontSize: 9,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textAlign: "left",
                    }}
                  >
                    {t('Description')}
                  </span>
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  <span
                    style={{
                      color: "#6b7280",
                      fontSize: 9,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textAlign: "center",
                    }}
                  >
                    {t("Quantity")}
                  </span>
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  <span
                    style={{
                      color: "#6b7280",
                      fontSize: 9,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textAlign: "center",
                    }}
                  >
                    {t("Unit ")}
                  </span>
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  <span
                    style={{
                      color: "#6b7280",
                      fontSize: 9,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textAlign: "left",
                    }}
                  >
                    {t("Item Price HT")}
                  </span>
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  <span
                    style={{
                      color: "#6b7280",
                      fontSize: 9,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textAlign: "right",
                    }}
                  >
                    {t("Amount HT")}
                  </span>
                </Text>
              </View>
            </View>
            {rows?.map((item, i) => (
              <View key={i} style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    {item.title?.substring(0, 20)}
                  </Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCellQuantity}>
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: "bold",
                        textAlign: "center",
                        alignItems: "center",
                        fontFamily: "Open Sans",
                      }}
                    >
                      {item.quantity}
                    </span>
                  </Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCellQuantity}>
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: "bold",
                        textAlign: "center",
                        alignItems: "center",
                        fontFamily: "Open Sans",
                      }}
                    >
                      {item.unit}
                    </span>
                  </Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: "bold",
                        textAlign: "left",
                        fontFamily: "Open Sans",
                      }}
                    >

                      {item.price} {t('dt')}
                    </span>
                  </Text>
                </View>

                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    <span
                      style={{
                        fontSize: 10,
                        color: "#ef4444",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontFamily: "Open Sans",
                      }}
                    >

                      {parseFloat(item.price * item.quantity).toFixed(2)} {t('dt')}
                    </span>
                  </Text>
                </View>
              </View>
            ))}
          </View>

          <View style={styles.invoiceThird}>
            <View style={{ width: "100%", alignItems: "baseline" }}>
              <Text style={styles.title}>

                <div style={{ textAlign: "right" }}>
                  {t("Total HT")}: {'   '}
                  <Text style={{ fontSize: 10, color: "#0e9f6e" }}>
                    {data?.totalAmount}
                  </Text>
                </div>
              </Text>
            </View>
            <View style={{ width: "100%", alignItems: "baseline" }}>

            <Text style={styles.title}>
                <div style={{ textAlign: "right" }}>{t("discount")}: {'   '}
                  <Text style={styles.title}>
                    <div style={{ textAlign: "right" }}>
                      <span style={styles.infoCost}>
                        {" "}

                        {parseFloat(data?.discount).toFixed(2) || 0}%
                      </span>
                    </div>
                  </Text>
                </div>
              </Text>

             

            </View>


            <View style={{ width: "100%", alignItems: "baseline" }}>
            <Text style={styles.title}>
                <div style={{ textAlign: "right" }}>
                  {t('Tax Rate')}: {'   '}


                  <Text style={styles.title}>
                    <div style={{ textAlign: "right" }}>
                      <span style={styles.infoCost}>


                        {parseFloat(data?.taxRate).toFixed(2)}%
                      </span>
                    </div>
                  </Text>
                </div>
              </Text>

            </View>
            <View style={{ width: "100%", alignItems: "baseline" }}>
              <Text style={styles.title}>
                <span style={{ textAlign: "right" }}>{t("Adjustments")}: {'   '}
                  <Text style={styles.title}>
                    <div style={{ textAlign: "right" }}>
                      <span style={styles.infoCost}>

                        {parseFloat(data?.adjustments).toFixed(2)} {t('dt')}
                      </span>
                    </div>
                  </Text> </span>
              </Text>

            </View>
            <View style={{ width: "100%", alignItems: "baseline" }}>
              <Text style={styles.title}>
                <div
                  style={{ width: "45%", textAlign: "right", float: "left" }}
                >
                  {t('Total TTC')}: {'   '}

                  <Text style={styles.title}>
                    <span style={styles.totalAmount}>

                      {parseFloat(data?.total).toFixed(2)} {t('dt')}
                    </span>
                  </Text>
                </div>
              </Text>

            </View>
          </View>


          <View
            style={{
              textAlign: "left",
              fontSize: 12,
              paddingBottom: 30,
              paddingTop: 30,
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <Text style={styles.info}>
              {data?.quoteDescription && (
                <span>
                  {data.quoteDescription}
                </span>
              )}
            </Text>
          </View>
        </Page>
      </Document>
    </>
  );
};

export default InvoiceForDownload;
